var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"profilePicture",staticClass:"rounded-full",attrs:{"src":!!_vm.url ? _vm.url : '/img/default-user-icon.4aa4dc7e.jpg',"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }